import styled from 'styled-components';

export const MembershipAvailable = styled.div`
  border-bottom: 1px solid #F0F0F0; 
  display: flex;
  flex-direction: row; 
  justify-content: flex-end;
  margin-bottom: 20px; 
  padding: 6px 0px 26px 0px; 
  width: 100%;
`;

export const ManageHeaderContent = styled.div`
  justify-content: space-between;
  margin-bottom: 25px;
  display: flex;

  @media (max-width: 588px) {
    margin-left: -200px;
    padding-left: 255px;
  }

  @media (max-width: 1170px) {
    justify-content: center;
    flex-direction: column;
    padding-bottom: 360px;
    margin-bottom: -350px;
    align-items: center;
    overflow-x: auto;

    & > div:first-of-type {
      margin-bottom: 10px;
    }
  }
`;

export const ManageHeaderLeft = styled.div`
  display: flex;
`;

export const ManageHeaderWrapper = styled.div`
  margin: 0 5px;
`;

export const DeleteContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  margin: 20px;
`;
export const MembershipSection = styled.div`
  width: 305px;
  font-weight: 400;
`;
export const MembershipMessage = styled.div`
  padding: 25px 40px;
  border-bottom: solid 1px var(--LightGray);
`;
export const MembershipButton = styled.div``;
export const CloseModalButton = styled.div`
  margin: 16px 40px 21px 40px;
  height: 40px;
  background-color: var(--PrimaryBlue);
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
`;
export const ModalBackground = styled.div`
  z-index: -1;
`;
